document.addEventListener('DOMContentLoaded', function () {
    function addPaginationListeners() {
        document.querySelectorAll('.page-number').forEach(function (pageLink) {
            pageLink.addEventListener('click', function () {
                var page = this.getAttribute('data-page');
                fetch(ajaxurl + '?action=load_actualites_page&page=' + page)
                    .then(response => response.text())
                    .then(data => {
                        document.getElementById('actualites-wrapper').innerHTML = data;
                        addPaginationListeners();  // Re-attach listeners after updating DOM
                    })
                    .catch(error => {
                        console.error('Error fetching articles:', error);
                    });
            });
        });
    }

    addPaginationListeners();
});